import React, {FC} from "react"
import ProductInfoSection from "../components/ProductInfoSection"
import StepsGrid from "../components/StepsGrid"

const steps = [
  {
    title: "annualLeavePurchase.landing.steps.stepOne.title",
    subTitle: "annualLeavePurchase.landing.steps.stepOne.subTitle",
    image: "https://res.cloudinary.com/perkbox/image/upload/v1742926537/0ff02d1a-a809-4510-9bae-e281e2b08509.png"
  },
  {
    title: "annualLeavePurchase.landing.steps.stepTwo.title",
    subTitle: "annualLeavePurchase.landing.steps.stepTwo.subTitle",
    image: "https://res.cloudinary.com/perkbox/image/upload/v1742926613/37896af2-9483-47c9-9cdb-9edaf2ee476a.png"
  },
  {
    title: "annualLeavePurchase.landing.steps.stepThree.title",
    subTitle: "annualLeavePurchase.landing.steps.stepThree.subTitle",
    image: "https://res.cloudinary.com/perkbox/image/upload/v1742926648/9c5c73c8-3f04-4a77-9d3b-377bdb02a898.png"
  }
]

const AnnualLeavePurchaseLandingScreen: FC = () => {
  return (
    <>
      <ProductInfoSection
        title="annualLeavePurchase.landing.title"
        subTitle="annualLeavePurchase.landing.sectionOne.subTitle"
        imagePosition="right"
        body="annualLeavePurchase.landing.sectionOne.body"
        ctaText="annualLeavePurchase.landing.sectionOne.cta.text"
        hasAlert
      />

      <StepsGrid itemsPerRow={3} items={steps} />

      <ProductInfoSection
        subTitle="annualLeavePurchase.landing.sectionTwo.subTitle"
        imagePosition="left"
        body="annualLeavePurchase.landing.sectionTwo.body"
        ctaText="annualLeavePurchase.landing.sectionOne.cta.text"
      />
    </>
  )
}

export default AnnualLeavePurchaseLandingScreen
